import { isEmpty, map, pipe, join } from "remeda";

function sanitizeCsvValue(value: unknown): string {
  if (value == null) {
    return "";
  }

  let str = typeof value === "string" ? value.trim() : "";

  if (/^[=+\-@]/.test(str)) {
    str = `'${str}`;
  }

  const escaped = str.replace(/"/g, '""');

  if (escaped.includes(",") || escaped.includes('"')) {
    return `"${escaped}"`;
  }

  return escaped;
}

function createCsvRow<T extends object>(headers: ReadonlyArray<keyof T>) {
  return (item: T): string =>
    pipe(
      headers,
      map((header) => sanitizeCsvValue(item[header])),
      join(","),
    );
}

function createCsvString<T extends object>(data: ReadonlyArray<T>): string {
  if (isEmpty(data)) {
    return "";
  }

  const headers = Object.keys(data[0]) as (keyof T)[];

  const rows = pipe(data, map(createCsvRow(headers)));

  const headerRow = headers.join(",");

  return pipe([headerRow, ...rows], join("\n"));
}

function downloadCsvString(csvString: string, fileName: string): void {
  const blob = new Blob([csvString], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");

  a.setAttribute("hidden", "");
  a.setAttribute("href", url);
  a.setAttribute("download", fileName);

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function exportDataToCsv<T extends object>(
  data: ReadonlyArray<T>,
  fileName = "export.csv",
): void {
  if (isEmpty(data)) {
    alert("No data to export.");
    return;
  }

  pipe(data, createCsvString, (csvString) =>
    downloadCsvString(csvString, fileName),
  );
}
